module.exports = __webpack_public_path__ + "static/media/YDSM2.8ae87b72.jpg";